import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './App.css';
import { deletePhoto } from './photoDB';
import { clearGlobalState } from './globalState';
import { clearSession } from './api';

function ThankYou() {
  const location = useLocation();
  const navigate = useNavigate();

  const isSupport = location.state?.support;
  // Full set of IndexedDB photo keys captured during this session.
  // Sent here by PhotoConfirm so we can wipe them after a confirmed,
  // successful submission.
  const allPhotoKeys = location.state?.allPhotoKeys || [];

  const timestamp = new Date().toLocaleString();

  // Delete all session photos from IndexedDB on arrival.
  // Only runs when there are keys to clean up (photo submission flows).
  // Failures are non-critical — log and move on.
  useEffect(() => {
    if (allPhotoKeys.length === 0) return;
    Promise.all(allPhotoKeys.map(key => deletePhoto(key))).catch(err => {
      console.warn('Could not clear session photos from IndexedDB:', err);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleReturnHome = () => {
    // End the dealer session entirely: identity, session token, and the
    // photos were all consumed by this submission.
    clearGlobalState();
    clearSession();
    navigate('/');
  };

  return (
    <div className="ThankYou">
      <h1>Thank You!</h1>
      {isSupport ? (
        <p>Your support request has been sent. We'll get back to you soon.</p>
      ) : (
        <p>Your photos have been successfully sent!</p>
      )}
      <div className="ThankYou-timestamp">
        <strong>Submitted:</strong> {timestamp}
      </div>
      <button className="App-button" onClick={handleReturnHome} style={{ marginTop: 24 }}>
        Return to Home
      </button>
    </div>
  );
}

export default ThankYou;
